/**
 * @export
 * @class TradeInfo
 * 거래정보
 */
export default class TradeInfo {
  constructor() {
    this.welWrapper = $('#_wrapTradeInfo');

    this.render();
    this.setEvent();
  }

  render() {
    const sHtml = `<div class="bx_ct">
                <div class="ct_wrp">
                    <button type="button" data-role="toggleButton" class="toggle tit_align_top">
                        <h4>거래정보</h4>
                    </button>
                    <div class="ct slide-ct">
                        <table class="tbl_info" cellSpacing="0">
                            <tbody>
                                <tr>
                                    <th scope="row">재화 등의 공급방법 및 공급시기</th>
                                    <td>
                                        배송상품 : 컨텐츠에 기재된 상세설명 참조<br />
                                        그 외 상품 : 구매내역 및 예약번호 등을 문자메세지로 전송
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">청약철회 및 계약의 해제에 관한 사항</th>
                                    <td>컨텐츠에 기재된 배송/환불 정보 및 상세설명 참조</td>
                                </tr>
                                <tr>
                                    <th scope="row">재화 등의 교환 반품 보증과 그 대금 환불 및<br />환불의 지연에 따른 배상금 지급의 조건 절차</th>
                                    <td>
                                        주문 취소 및 결제대금 환급 신청 방법<br />
                                        - 배송상품 : 주문취소 및 결제대금의 환급 신청은 로그인 후 &#39;마이티몬&#39;에서 확인<br />
                                        - 그 외 상품 : 티몬 모바일 앱 [마이티몬>고객센터] 내 1:1채팅상담 문의<br />
                                        대금 환불 및 환불의 지연에 따른 배상금 지급의 조건 절차<br />
                                        - 전자상거래 등에서의 소비자 보호에 관한 법률의 규정에 따름
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">소비자피해보상의 처리, 재화 등에 대한 불만 처리 및<br />소비자와 사업자 사이의 분쟁처리에 관한 사항</th>
                                    <td>티몬 모바일 앱 [마이티몬>고객센터] 내 1:1채팅상담 문의</td>
                                </tr>
                                <tr>
                                    <th scope="row">거래에 관한 약관의 내용 또는 확인할 수 있는 방법</th>
                                    <td>웹 페이지 하단 이용약관 참조</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>`;

    this.welWrapper.html(sHtml);
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
  }

  clearEvent() {
    this.welWrapper.off('click', '[data-role=toggleButton]');
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    $(e.currentTarget).toggleClass('open');
  };
}
